import React from 'react';

import { Box, Typography } from '@mui/material';

type ReadOnlyFieldProps = {
  /** フィールドラベル */
  label: string;
  /** 表示値 */
  value: string;
};

/**
 * 参照専用フィールド。
 * disabled な入力フォームではなくテキスト表示とする。
 */
const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({ label, value }) => {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" fontWeight={500} sx={{ mb: 0.25 }}>
        {label}
      </Typography>
      <Typography variant="body1" sx={{ mt: 0.25 }}>
        {value || '-'}
      </Typography>
    </Box>
  );
};

export default ReadOnlyField;
